import { render, staticRenderFns } from "./FederalEdit.vue?vue&type=template&id=b6162328&"
import script from "./FederalEdit.vue?vue&type=script&lang=js&"
export * from "./FederalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports